/* import __COLOCATED_TEMPLATE__ from './captcha.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();